import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static classes = ['active']

  toggle ({ currentTarget }) {
    $(this.element).toggleClass(this.activeClass, currentTarget.checked)
  }
}
